import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { useState, useEffect } from "react";
import logo from '../assets/img/pfp-img.png';
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';

export const NavBar = () => {
    const [activeLink, setActiveLink] = useState('home');
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const scrollTo = (id) => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <Navbar expand="lg" className={scrolled ? "scrolled" : ""}>
            <Container>
                <Navbar.Brand href="#home" onClick={() => setActiveLink('home')}>
                    <img src={logo} alt="Ayomikun" />
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="main-navbar">
                    <span className="navbar-toggler-icon" />
                </Navbar.Toggle>

                <Navbar.Collapse id="main-navbar">
                    <Nav className="me-auto">
                        <Nav.Link
                            href="#home"
                            className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'}
                            onClick={() => setActiveLink('home')}
                        >
                            Home
                        </Nav.Link>
                        <Nav.Link
                            href="#services"
                            className={activeLink === 'services' ? 'active navbar-link' : 'navbar-link'}
                            onClick={() => setActiveLink('services')}
                        >
                            Services
                        </Nav.Link>
                        <Nav.Link
                            href="#skills"
                            className={activeLink === 'skills' ? 'active navbar-link' : 'navbar-link'}
                            onClick={() => setActiveLink('skills')}
                        >
                            Skills
                        </Nav.Link>
                        <Nav.Link
                            href="#project"
                            className={activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'}
                            onClick={() => setActiveLink('projects')}
                        >
                            Projects
                        </Nav.Link>
                        <Nav.Link
                            href="#connect"
                            className={activeLink === 'contact' ? 'active navbar-link' : 'navbar-link'}
                            onClick={() => setActiveLink('contact')}
                        >
                            Contact
                        </Nav.Link>
                    </Nav>

                    <span className="navbar-text">
                        <div className="social-icon">
                            <a href="https://www.instagram.com/mikun.dev/" target="_blank" rel="noreferrer">
                                <img src={navIcon3} alt="Instagram" />
                            </a>
                            <a href="https://x.com/_Ayomikun" target="_blank" rel="noreferrer">
                                <img src={navIcon2} alt="X / Twitter" />
                            </a>
                            <a href="https://github.com/Ayomikun2820" target="_blank" rel="noreferrer">
                                <img src={navIcon1} alt="GitHub" />
                            </a>
                        </div>
                        <button onClick={() => scrollTo('connect')}>
                            <span>Let's Connect</span>
                        </button>
                    </span>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default NavBar;
